import React, { useEffect, useCallback, useState} from 'react';
import SavePluginModal from 'components/modals/SavePluginModal.js';
import ConvertTrackModal from "components/modals/ConvertTrackModal.js";
import FreezeModal from "components/freeze/FreezeModal.js";
import HicDialog from 'components/nft/HicDialog.js';
import ZoraDialog from 'components/nft/ZoraDialog.js';
import SettingsModal from 'components/modals/SettingsModal.js';
import ProjectsModal from 'components/modals/ProjectsModal.js';
import ProgressBar from 'components/progressbar/ProgressBar.js';
import UnknownProgressBar from 'components/progressbar/UnknownProgressBar.js';
import LoginModal from 'components/modals/LoginModal.js';
import SavePresetModal from 'components/modals/SavePresetModal.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import Convert from "components/modals/ConvertTrackModal.js";
import GuildsModal from "components/modals/GuildsModal.js";
import {connect} from 'react-redux';

const Modals = (props) => { 
    let loadingSequence = Object.keys(props.loadingSequence).some(
        (s) => props.loadingSequence[s]);

    console.log("LOADING SEQUENCE= ", loadingSequence);

    return (
        <div>
          <ConditionedComponent condition={props.showLogin}>
	    <LoginModal show={props.showLogin}/>
          </ConditionedComponent>
          {props.hicDialog && <HicDialog hicDialog={props.hicDialog}/>}
          {props.zoraDialog && <ZoraDialog data={props.zoraDialog} sequencerEngine={props.sequencerEngine}/>}
          {loadingSequence ? 
           <ProgressBar sequencerEngine={props.sequencerEngine}/> : ''}
          {props.isPreparingNFT ? 
           <UnknownProgressBar text={"Preparing your NFT"} sequencerEngine={props.sequencerEngine}/> : ''}
          {props.loadingText ? 
           <UnknownProgressBar text={props.loadingText} sequencerEngine={props.sequencerEngine}/> : ''}
          {props.transcribing ? 
           <UnknownProgressBar text="Transcribing" sequencerEngine={props.sequencerEngine}/> : ''}
           <GuildsModal/>
          {props.uploadingFile ? 
           <UnknownProgressBar text="Uploading File" sequencerEngine={props.sequencerEngine}/> : ''}
          {props.showSettings ?
           <SettingsModal sequencerEngine={props.sequencerEngine}/> : ''}
          {props.trackPresetSaving ?
           <SavePresetModal sequencerEngine={props.sequencerEngine}/> : ''}
          {props.showProjectsModal ?
           <ProjectsModal sequencerEngine={props.sequencerEngine}/> : ''}
          {props.trackToConvert ?
           <ConvertTrackModal show={true} track={props.trackToConvert} sequencerEngine={props.sequencerEngine}/> : ''}
          {props.showFreezeModal && 
           <FreezeModal sequencerEngine={props.sequencerEngine}/>}
          {props.pluginToSave &&  
           <SavePluginModal zobject={props.pluginToSave}/>}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      trackPresetSaving: state.presets.trackPresetSaving,
      showLogin: state.sequencer.showLogin,
      transcribing: state.sequencer.isTranscribing,
      loadingText: state.sequencer.loadingText,
      loadingSequence: state.sequencer.loadingSequence,
      uploadingFile: state.sequencer.uploadingFile,
      showSettings: state.sequencer.showSettings,
      hicDialog: state.nft.hicDialog,
      zoraDialog: state.nft.zoraDialog,
      isPreparingNFT: state.nft.isPreparingNFT,
      showProjectsModal: state.spatial.showProjectsModal,
      trackToConvert: state.tracks.trackToConvert,
      pluginToSave: state.plugins.pluginToSave,
      showFreezeModal: state.freeze.showFreezeModal
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
